import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from "@emotion/react";
import { Checkbox } from "../atoms/checkbox";
import { styled } from "../../theme";
import { TOOLTIP_LENGTH_DEFAULT } from "./consts";
import { CheckboxWrapper, ClickOutsideWrapper, Label, LabelText, StyledDatePicker, } from "./styles";
const defaultChildren = ({ Checkbox, Label, FormattedDate, }) => (_jsxs(_Fragment, { children: [_jsx(Checkbox, {}), _jsx(Label, {}), _jsx(FormattedDate, {})] }));
const defaultRenderNotApplicableStatusOption = ({ icon, onClick, active, StyledDropdownSelectOption, }) => (_jsxs(StyledDropdownSelectOption, { active: active, onClick: onClick, children: [icon, "Not Applicable"] }));
export const defaultTaskCheckboxFieldProps = {
    tooltipLength: TOOLTIP_LENGTH_DEFAULT,
    Checkbox,
    CheckboxWrapper,
    ClickOutsideWrapper,
    Label,
    LabelText,
    DatePicker: StyledDatePicker,
    children: defaultChildren,
    renderNotApplicableStatusOption: defaultRenderNotApplicableStatusOption,
};
export const taskCheckboxSmallOverrides = {
    size: "small",
    Checkbox: styled(defaultTaskCheckboxFieldProps.Checkbox) `
    border-width: 1px;
  `,
    CheckboxWrapper: styled(defaultTaskCheckboxFieldProps.CheckboxWrapper) `
    margin-bottom: 0;

    div {
      margin-bottom: 0;
    }
  `,
    Label: styled(defaultTaskCheckboxFieldProps.Label) `
    line-height: 1;
  `,
    LabelText: styled(defaultTaskCheckboxFieldProps.LabelText) `
    font-size: 1em;
  `,
};
export const taskCheckboxFadedSmallOverrides = {
    size: "small",
    Checkbox: styled(defaultTaskCheckboxFieldProps.Checkbox) `
      border-width: 1px;

      ${({ checked, disabled, theme }) => !checked &&
        !disabled &&
        css `
          border-color: ${theme.color.darkBlue100};
          background: ${theme.color.white};
        `}
    `,
    CheckboxWrapper: styled(defaultTaskCheckboxFieldProps.CheckboxWrapper) `
      margin-bottom: 0;

      div {
        margin-bottom: 0;
      }

      ${({ checked, disabled, theme }) => (checked || disabled) &&
        css `
          color: ${theme.color.gray100};
        `}
    `,
    Label: styled(defaultTaskCheckboxFieldProps.Label) `
      line-height: 1;
    `,
    LabelText: styled(defaultTaskCheckboxFieldProps.LabelText) `
      padding: 0 5px;
      font-size: 1em;
    `,
};
